export var size_xs = '10px';
export var size_sm = '12px';
export var size_md = '14px';
export var size_lg = '16px';
export var size_xl = '18px';
export var size_xxl = '20px';
//# sourceMappingURL=fonts.js.map